// extracted by mini-css-extract-plugin
export default {"button":"SvgIconButton_button__hguvA","dangerous":"SvgIconButton_dangerous__ZR7Nn","small":"SvgIconButton_small__iWjM5"};